import * as React from 'react';
import { EDescriptionType, TDescription } from '../../types/suburban';
import { ListDescription, ParagraphDescription } from './components';

interface IDescriptionProps {
  description: TDescription;
}

export const MortgageProgramDescription: React.VFC<IDescriptionProps> = ({ description }) => {
  return (
    <>
      {description.type === EDescriptionType.LIST && <ListDescription list={description.value} />}
      {description.type === EDescriptionType.PARAGRAPH && <ParagraphDescription text={description.value} />}
    </>
  );
};
